import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";

interface Props {
  fieldName: string;
  value?: string;
  options: {
    value: string;
    label: string;
  }[];
  onChange: (value: string) => void;
  disabled?: boolean;
  ariaDescribedBy?: string;
  required?: boolean;
}

export default function RadioInput({
  fieldName,
  value,
  options,
  onChange,
  disabled,
  ariaDescribedBy,
  required = false,
}: Props) {
  const [selected, setSelected] = useState<string>(value || options[0].value);

  useEffect(() => {
    if (value) {
      setSelected(value);
    }
  }, [value]);

  return (
    <>
      {options.map(({ value, label }, index) => (
        <div
          key={`radio-${fieldName}-${value}`}
          className="radio-input position-relative"
        >
          <Form.Check
            type="radio"
            name={fieldName}
            id={`radio-${fieldName}-${value}`}
            checked={selected === value}
            label={label}
            disabled={disabled}
            required={required && index === 0}
            aria-describedby={ariaDescribedBy}
            onChange={() => {
              setSelected(value);
              onChange(value);
            }}
          />
        </div>
      ))}
    </>
  );
}
